import App from './App.vue'
import Vue from 'vue'

const mount = document.querySelector('#table-filter')

if (mount) {
  new Vue({
    render: h => h(App)
  }).$mount(mount)
}
